import Vue from 'vue'

const Data = {

   endpoint: '',

   find: async function () {
      return await Vue.prototype.$api._get(this.endpoint);

   },

   findOneById: async function (id) {
      return await Vue.prototype.$api._get(`${this.endpoint}/${id}`);
   },

   create: async function (payload) {
      return await Vue.prototype.$api._post(this.endpoint, payload);
   },

   create2: async function (payload) {
      return await Vue.prototype.$api._post2(this.endpoint, payload);
   },

   destroyById: async function (id) {
      return await Vue.prototype.$api._delete(`${this.endpoint}/${id}`);
   },

   updatedById: async function (id, payload) {
      return await Vue.prototype.$api._patch(`${this.endpoint}/${id}`, payload);
   },

   update: async function (payload) {
      return await Vue.prototype.$api._patch(`${this.endpoint}`, payload);
   },

   uploadImageById: async function (id, payload) {
      return await Vue.prototype.$api.uploadImage(`${this.endpoint}/${id}`, payload);
   }
}

export default Data


// WEBPACK FOOTER //
// ./src/api/data/data.js